import { useState, useEffect } from 'react';

const useIsMobile = (breakpoint = 768) => {
  // Lazy-init from the real viewport width on first render instead of
  // hardcoding false - this is a client-only SPA (no SSR), so window is
  // always available, and initializing to false meant every page briefly
  // rendered its desktop layout (full data table, desktop header) before
  // the mount effect below corrected it one tick later.
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth <= breakpoint
  );

  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    // Check on mount
    checkIfMobile();

    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, [breakpoint]);

  return isMobile;
};

export default useIsMobile;
